import { useContext } from 'react'

import {
  type SanityDictionaryEntryOptions,
  type SanityDictionaryEntryPreview,
} from '@data/sanity/queries/types/dictionary'
import { getFormattedDate } from '@lib/format'
import { LanguageContext } from '@lib/language'
import { getLinkPageUrl } from '@lib/routes'
import { StringsContext } from '@lib/strings'

import SimpleLink from '@components/simple-link'

interface DictionaryEntryHeaderProps {
  entry: SanityDictionaryEntryPreview
  options?: SanityDictionaryEntryOptions
}

const DictionaryEntryHeader = ({
  entry,
  options,
}: DictionaryEntryHeaderProps) => {
  const { locale } = useContext(LanguageContext)
  const strings = useContext(StringsContext)

  const dictionaryPageUrl = getLinkPageUrl('dictionaryPage')
  const dictionaryEntryUrl = getLinkPageUrl('dictionaryEntry', entry.slug)

  return (
    <>
      <section className="container pt-2">
        <SimpleLink href={dictionaryPageUrl} className="text-sm text-green">
          {strings.dictionary}
        </SimpleLink>{' '}
        <span className="text-sm text-green">/</span>{' '}
        <SimpleLink href={dictionaryEntryUrl} className="text-sm text-green">
          {entry.title}
        </SimpleLink>
      </section>
      <section className="container pt-8 md:pt-10 flex flex-col justify-center items-center">
        <div className="w-full max-w-3xl mb-6">
          <h1 className="text-center">{entry.title}</h1>
          {options?.showExcerpt && (
            <p className="text-xl text-center mt-7">{entry.excerpt}</p>
          )}
          {options?.showDate && (
            <div className="flex items-center mt-5">
              <p className="w-full text-sm text-center">
                {strings.lastUpdated}{' '}
                {getFormattedDate(entry.lastUpdatedDate, locale)}
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  )
}

export default DictionaryEntryHeader
